"use strict";
/**
 * Component: AppMenu.tsx
 * Llenguatge: TypeScrypt
 * Autor: Jordi Riu
 * Versió: 1.1
 * Data: 05/04/2017
 * (c) Ajuntament de Manresa - abr 2017 - Departament de Sistemes d'Informació
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var core_1 = require("@material-ui/core");

var AppMenu = function AppMenu(props) {
  return React.createElement(core_1.List, {
    style: props.style
  }, props.children);
};

exports.default = AppMenu;